//todo : refactor (LIT-499196)
import './quick-search-core';
import 'element-closest-polyfill';
import {keyCodes} from '../../../utility/js/utils';

var vPort = 'screen-md',
    $qSearch = null,
    $form = null,
    $allFieldInput = null,
    $sortByInput = null,
    href = null,
    $quickSearch = null,
    $qsW = null,
    disabledFields = null,
    actualQuickSearchInputEl = null,
    homePgaeActualQSInputEl = null,
    searchTypeDropdownEl = null;

UX.quickSearch.vPort = 'screen-lg';

UX.quickSearch.additionalController = function () {
    actualQuickSearchInputEl = document.querySelector('.quick-search-wrapper .actualQSInput');
    homePgaeActualQSInputEl = document.querySelector('.homepage-search-wrapper .actualQSInput');
    searchTypeDropdownEl = document.querySelector('.search-within');

    if (actualQuickSearchInputEl || homePgaeActualQSInputEl) {
        UX.quickSearch.handleQSAutocompleteA11Y();
    }

    if (!window.highlight) {
        window.highlight = function () {};
    }

    $(document).on(UX.quickSearch.vPort + '-on', function () {
        // Waiting for custom event that will be triggered by controller.js to activate responsive effects
        UX.quickSearch.isMobile = true;
    });

    $(document).on(UX.quickSearch.vPort + '-off', function () {
        // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
        UX.quickSearch.isMobile = false;
    });

    $(document).on('focus', '.quick-search:not(.quick-search--citation) input.fakeQSInput', function () {
        if (!$(this).closest('.expanded--quickSearch').length) {
            UX.quickSearch.addTransition();
            UX.quickSearch.open($(this));
        }
    });

    $(document).on('focus', '.quick-search:not(.quick-search--citation) input.actualQSInput', function (e) {
        var $qsW = $(this).closest('.quick-search');

        if (!$qsW.hasClass('open')) {
            if (!$(this).closest('.expanded--quickSearch').length) {
                UX.quickSearch.open($(this));
            }
        }
    });

    $(document).on('focus', '.expanded--quickSearch input.actualQSInput', function () {
        $(this).siblings('.search-options-wrapper').stop().slideDown(550);
    });

    $(document).on('click', function (e) {
        if (
            !$(e.target).closest('.main-search-field-wrapper, .search-options-wrapper').length &&
            !$('.header-quicksearch').hasClass('expanded--quickSearch') &&
            !$(e.target).hasClass('qsItem') &&
            !$(e.target).closest('.qsItem').length &&
            !$(e.target).closest('.qsaItem').length
        ) {
            UX.quickSearch.close();
        }
    });

    $(document).on(vPort + '-on', function () {
        $(document).on('touchstart', function (e) {
            if (
                !$(e.target).parents().is('.quickSearchFormContainer') &&
                !$(e.target).parents().is('.header-quicksearch') &&
                $('.quickSearchFormContainer').css('display') === 'block' &&
                !$('.quickSearchFormContainer').parents().is('.homepage-search-container') &&
                !e.target.classList.contains('qsItem') &&
                !e.target.closest('.qsItem') &&
                !e.target.closest('.qsaItem')
            ) {
                $('.quickSearchFormContainer')
                    .css('display', 'none')
                    .siblings('.quick-search__item')
                    .removeClass('active');
            }
        });
    });

    $('#citationSearchForm').on('click', '[type="submit"]', function (e) {
        e.preventDefault();
        if (!$(e.target).closest('.ms-sel-ctn').length) {
            UX.quickSearch.submitCitationForm('#citationSearchForm');
        }
    });

    $(document).on('keyup', '#citationSearchForm input', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ((e.keyCode || e.which) === 13 && !$(e.target).closest('.ms-sel-ctn').length) {
            UX.quickSearch.submitCitationForm('#citationSearchForm');
        }
    });

    $(document).on('keyup', function (e) {
        var keyCode = e.keyCode || e.which;

        if (keyCode === 9) {
            if ($(document.activeElement).closest('.quick-search-wrapper').length === 0) {
                UX.quickSearch.close();
            }
        }
    });

    $(document).on('click', '.quickSearchAutocomplete a', function (e) {
        $('.quick-search input').blur();
    });

    $(document).on('click', '[title="Citation"]', function (e) {
        $('.quick-search').addClass('citationSearch--open');
    });

    $(document).on('click', '.citationSearch--open [data-toggle="tab"]', function (e) {
        $('.quick-search').removeClass('citationSearch--open');
    });

    $('.quick-search__item').on('click', function (e) {
        e.preventDefault();
        $qSearch = $(this).siblings('.quick-search');
        if ($qSearch.is(':visible')) {
            $qSearch.css('display', '');
        } else {
            $qSearch.css('display', 'block');
        }

        $(this).toggleClass('active');
        $(this).attr('aria-label', $(this).hasClass('active') ? 'Close search' : 'Search');

        if ($qSearch.is(':visible')) {
            $qSearch.find('input').focus();
        } else {
            $qSearch.find('input').blur();
        }

        UX.quickSearch.setPosition();
    });

    $('.quick-search').on('input', '.actualQSInput', function () {
        $('.quick-search .actualQSInput').val($(this).val());
    });

    window.addEventListener('resize', () => {
        const screenWidth = window.innerWidth,
            actualQSInput = '.quick-search:not(.quick-search--citation) input.actualQSInput',
            quickSearchItem = document.querySelector('.quick-search__item'),
            isQuickSearchItemActive = quickSearchItem?.classList.contains('active'),
            quickSearch = document.querySelector('.quick-search'),
            isQuickSearchOpen = quickSearch?.classList.contains('open');

        UX.quickSearch.setPosition();

        if (
            screenWidth >= UX.grid.screenLg &&
            actualQuickSearchInputEl?.value &&
            (isQuickSearchOpen || isQuickSearchItemActive)
        ) {
            UX.quickSearch.removeTransition();
            UX.quickSearch.open($(actualQSInput));
        } else if (screenWidth < UX.grid.screenLg && actualQuickSearchInputEl?.value) {
            UX.quickSearch.addTransition();

            if (!quickSearchItem.classList.contains('active') && screenWidth > UX.grid.screenSm) {
                quickSearchItem.click();
            }

            if (screenWidth < UX.grid.screenSm) {
                quickSearch.style.left = '0';
            }
        } else {
            UX.quickSearch.addTransition();
            UX.quickSearch.close();
        }
    });

    $(window).on('orientationchange', function (event) {
        $('.quick-search input').blur();
        UX.quickSearch.close();
    });

    $('.facetQuickSearchForm').on('submit', function (e) {
        e.preventDefault();

        $form = $(this);
        $allFieldInput = $form.find('[name="AllField"]');
        $sortByInput = $form.find('[name="sortBy"]');
        href = window.location.href;

        href = UX.utils.removeUrlParam('AllField', href);
        href = UX.utils.removeUrlParam('sortBy', href);

        if (!href.indexOf('facetQuickSearch') > -1) {
            if (href.indexOf('?') > -1) {
                href += '&facetQuickSearch=true';
            } else {
                href += '?facetQuickSearch=true';
            }
        }

        href += '&sortBy=' + $sortByInput.val();

        if ($allFieldInput.val() !== '') {
            href += '&AllField=' + $allFieldInput.val();
        }

        window.location.href = href;
    });

    $(document).ready(function () {
        if ($('.facetQuickSearchForm').length) {
            $('.facetQuickSearchForm').find('.js--disabled').removeClass('js--disabled');
        }
        if (
            window.location.href.indexOf('facetQuickSearch=true') > -1 &&
            window.location.href.indexOf('AllField') > -1
        ) {
            $('body').find('.facetQSInput').val(UX.utils.getUrlParameter('AllField'));
        }
    });

    $(document).on('change', '.quick-search #search-within', function (e) {
        var val = $(this).val();
        var $tabContent = $(this).next('.tab__content');
        $tabContent.find('.tab__pane').removeClass('active');
        $tabContent.find(val).addClass('active');
    });

    $('.quick-search #search-within').trigger('change');

    $(document).on(vPort + '-off', function () {
        $quickSearch = $('.quick-search');
        if ($quickSearch.css('width') !== 'auto') {
            $quickSearch.css('width', 'auto');
        }
    });

    $(window).on('load', function (e) {
        if (/publication=/.test(window.location)) {
            disabledFields = $('#citationSearchForm').find('input[name^="citation"][type="search"]');
            disabledFields.each(function (e) {
                $(this).removeAttr('disabled');
            });
        }
    });

    $(window).on('load', function () {
        if (window.location.href.indexOf('/search/advanced') > -1 || window.location.hash.indexOf('#citation') > -1) {
            $('.citation').attr('data-citation', true);
        }
    });

    $(document).ready(function () {
        if (window.location.href.indexOf('text1') > -1) {
            const searchTerm = document.getElementById('text1');
            searchTerm.value = UX.utils.getUrlParameter('text1').replaceAll('+', ' ');
        }
    });

    $(document).on('click', '[data-citation]', function () {
        location.reload();
    });

    $(document).on('click', '.search-options-wrapper a', function (e) {
        let $this = $(this),
            thisHref = $this.attr('href'),
            $targetInput = $this.closest('form').find('.actualQSInput'),
            targetInputVal = $targetInput.val(),
            isCitation = thisHref.indexOf('#citation') > -1 ? '#citation' : '',
            newHref = '';

        e.preventDefault();
        newHref = UX.utils.removeUrlParam('text1', thisHref).replace('#citation', '');
        newHref += (newHref.indexOf('?') > -1 ? '&text1=' : '?text1=') + targetInputVal + isCitation;
        window.location.href = newHref;
    });

    const quickSearchRouter = e => {
        if (e.target.classList.contains('result-item') || e.target.closest('.result-item')) {
            e.preventDefault();
            const quickSearchFormContainer = document.querySelector('.quickSearchFormContainer'),
                searchWithinEl = quickSearchFormContainer?.querySelector('.search-within'),
                searchWithinOption = searchWithinEl?.querySelector(`option[value="${searchWithinEl.value}"`),
                optionValue = searchWithinOption?.dataset.value;

            let itemTarget = e.target.closest('.result-item')
                    ? e.target.closest('.result-item')
                    : e.target.classList.contains('result-item'),
                itemHref = optionValue !== 'thisCategory' ? itemTarget.dataset.href : window.location.host,
                seriesKey = optionValue ? `${itemHref.includes('?') ? '&' : '?'}SeriesKey=${optionValue}` : '';
            window.location.href = `${itemHref}${seriesKey}`;
        }
    };

    document.addEventListener('click', quickSearchRouter);

    const citationSearchContainer = document.querySelector('.citationSearchContainer');
    if (citationSearchContainer) {
        const citation = {
                page: citationSearchContainer.querySelector('input[name="citationPage"]'),
                number: citationSearchContainer.querySelector('input[name="citationNumber"]'),
            },
            ariaRequiredSwitcher = e => {
                const current = e.target,
                    other = e.target.name === 'citationPage' ? citation.number : citation.page;

                if (UX.utils.isElementEmptyOrSpaces(other)) {
                    if (!UX.utils.isElementEmptyOrSpaces(current)) {
                        other.removeAttribute('aria-required');
                    } else {
                        [current, other].forEach(item => item.setAttribute('aria-required', 'true'));
                    }
                }
            };

        citation.page.addEventListener('input', ariaRequiredSwitcher);
        citation.number.addEventListener('input', ariaRequiredSwitcher);
    }
};

UX.quickSearch.open = function ($el) {
    if (!$el.closest('.homepage-search-wrapper').length) {
        $qsW = $el.closest('.quick-search');
        $qsW.addClass('open');

        if ($('.pageHeader').length) {
            $('.pageHeader').addClass('searchOpen');
        }
        $('body').addClass('searchOpen-body');
        $qsW.find('input.fakeQSInput').attr('tabindex', -1);

        setTimeout(function () {
            if ($qsW.hasClass('open')) {
                $qsW.find('.actualQSInput').focus();
            }
        }, 500);

        setTimeout(function () {
            if ($qsW.hasClass('open')) {
                $qsW.find('.search-options-wrapper')
                    .stop()
                    .slideDown(550, function () {
                        $el.closest('.main-search-field-wrapper').css('overflow', 'visible');
                    });

                $('.quickSearchAutocomplete').css({
                    position: 'fixed',
                });
            }
        }, 700);
    }
};

UX.quickSearch.close = function () {
    $('.quick-search').removeClass('open');
    $('.pageHeader').removeClass('searchOpen');

    $('body').removeClass('searchOpen-body');
    if (!UX.quickSearch.isMobile) {
        if ($('.quick-search').closest('.expanded--quickSearch').length) {
            $('.search-options-wrapper').stop().slideUp(500);
        } else {
            $('.main-search-field-wrapper').css('overflow', 'hidden');
            $('.search-options-wrapper').stop().hide(500);
            $('.quickSearchAutocomplete').css('padding-top', '0');
            //if ($('.quick-search .actualQSInput').val())
            $('.quick-search .fakeQSInput').val($('.quick-search .actualQSInput').val()).attr('tabindex', 13);
        }
    }
};

UX.quickSearch.setPosition = function () {
    $qSearch = $('.quick-search');

    if (
        $qSearch.closest('.homepage-search-wrapper').length === 0 &&
        !$qSearch.hasClass('quick-search--citation') &&
        UX.quickSearch.isMobile
    ) {
        $qSearch.css({
            width: $(window).width(),
            left: ($('.container').outerWidth() - $(window).width()) / 2,
        });
    } else {
        $qSearch[0].style.width = 'auto';
    }
};

UX.quickSearch.submitCitationForm = function ($elem) {
    const mainWrapper = document.querySelector('.citationSearchContainer'),
        form = mainWrapper?.querySelector($elem);

    if (form) {
        const citationSearchWrapper = mainWrapper.querySelector('.citation-search__wrapper'),
            formAlertList = mainWrapper.querySelectorAll('.formAlert'),
            errorMsgText = UX.quickSearch.errorMsgText(),
            inputs = {
                journalHidden: form.querySelector('[name="citationJournal[]"]'),
                journal: form.querySelector('#citationJournal'),
                year: form.querySelector('[name="citationIssueYear"]'),
                volume: form.querySelector('[name="citationVolume"]'),
                issue: form.querySelector('[name="citationIssue"]'),
                page: form.querySelector('[name="citationPage"]'),
                citation: form.querySelector('[name="citationNumber"]'),
            },
            singleInputAlert = el => {
                if (el && el.id) {
                    const elFormAlert = mainWrapper.querySelector(`.formAlert[data-for="${el.id}"]`),
                        elFormLabelText = mainWrapper
                            .querySelector(`label[for="${el.id}"]`)
                            .textContent.toLowerCase()
                            .replace('#', 'number');
                    elFormAlert.textContent = `Error: missing ${elFormLabelText} value`;
                    el.setAttribute('aria-describedby', elFormAlert.id);
                    el.setAttribute('aria-invalid', 'true');
                }
            },
            formErrorMessage = {
                show: message => {
                    const errorMsgEl = citationSearchWrapper.querySelector('.error');
                    errorMsgEl?.remove();
                    citationSearchWrapper.insertAdjacentHTML(
                        'beforeend',
                        `<div class="error" role="alert">${message}</div>`
                    );
                },
                hide: () => {
                    const errorMsgEl = citationSearchWrapper.querySelector('.error');
                    errorMsgEl?.remove();
                },
            },
            loading = {
                show: () => {
                    const loadingEL = mainWrapper.querySelector('.js--loading');
                    if (!loadingEL)
                        mainWrapper.insertAdjacentHTML(
                            'afterbegin',
                            '<div class="js--loading" aria-label="loading results" role="alert"></div>'
                        );
                },
                hide: () => {
                    const loadingEL = mainWrapper.querySelector('.js--loading');
                    if (loadingEL) loadingEL.remove();
                },
            },
            clearInputAlert = () => formAlertList.forEach(item => (item.textContent = ''));

        formErrorMessage.hide();
        clearInputAlert();

        if (!inputs.journalHidden) {
            formErrorMessage.show(errorMsgText.journal);
            singleInputAlert(inputs.journal);
            inputs.journal.focus();
        } else {
            if (UX.utils.isElementEmptyOrSpaces(inputs.volume)) {
                singleInputAlert(inputs.volume);
                singleInputAlert(inputs.page);
                singleInputAlert(inputs.citation);
                setTimeout(() => {
                    inputs.volume.focus();
                    formErrorMessage.show(errorMsgText.default);
                }, 25);
            } else {
                if (UX.utils.isElementEmptyOrSpaces(inputs.page) && UX.utils.isElementEmptyOrSpaces(inputs.citation)) {
                    singleInputAlert(inputs.page);
                    singleInputAlert(inputs.citation);
                    formErrorMessage.show(errorMsgText.default);
                    inputs.page.focus();
                } else {
                    inputs.journalHidden.value = inputs.journalHidden.value.replace(/['"]+/g, '');
                    loading.show();
                    let baseURL = `${window.location.origin}/action/citationSearch?`,
                        urlParams = '',
                        counter = 0;

                    for (const item in inputs) {
                        let separator = counter !== 0 ? '&' : '';
                        if (inputs[item]?.value) {
                            urlParams += `${separator}${inputs[item].name}=${inputs[item].value}`;
                        }
                        counter++;
                    }
                    baseURL += urlParams;
                    fetch(baseURL)
                        .then(response => response.json())
                        .then(data => {
                            loading.hide();
                            if (data.link) {
                                window.location = data.link;
                            } else {
                                const otherCitationSearch = mainWrapper.querySelector('.other-citation-search'),
                                    otherCitationSearchInputs = otherCitationSearch.querySelectorAll('input');

                                otherCitationSearchInputs[0].focus();
                                if (data.error) {
                                    formErrorMessage.show(data.error);
                                } else {
                                    formErrorMessage.show(errorMsgText.server);
                                }
                            }
                        });
                }
            }
        }
    }
};

UX.quickSearch.errorMsgText = function () {
    return {
        default: 'Volume and page number, or volume and Article ID, are required.',
        journal: 'Please enter journal title.',
        server: 'Something went wrong, please try again',
    };
};

UX.quickSearch.doSuggest = function () {
    const $citationJournal = $('.citation.magicsuggest'),
        maxWords = $citationJournal.data('max-words'),
        maxChars = $citationJournal.data('max-chars'),
        preVal = $citationJournal.val().split(','),
        preLabel = $citationJournal.data('label'),
        disabledFields = $('#citationSearchForm').find('input[name^="citation"][type="search"]');

    let ms = UX.quickSearch.magicSuggest($citationJournal, maxWords, maxChars);
    ms.input[0]?.setAttribute('aria-required', 'true');
    const $citationSearchContainer = $('.citationSearchContainer'),
        $msInputWrapper = $citationSearchContainer.find('.ms-sel-ctn'),
        $msInput = $msInputWrapper.find('.ms-input');

    if ($citationJournal.hasClass('pre-populated')) {
        ms.setSelection([{value: preVal, label: preLabel}]);
        disabledFields.each(function (e) {
            $(this).removeAttr('disabled');
        });
    }

    $('.ms-trigger').on('click', function () {
        var $triggerParent = $(this).parents('.main-search-field-wrapper'),
            isCitation = $(this).parents().is('.quick-search--citation');

        if (isCitation) {
            $triggerParent.css('overflow', 'visible');
        }
        if ($('.citationJournalName').find('.dropdown-menu').is(':visible')) {
            ms.getValue().length > 0 ? ms.collapse() : ms.expand();
        } else ms.getValue().length > 0 ? ms.expand() : ms.collapse();
    });

    $(ms).on('selectionchange', function (e) {
        $msInput.attr('aria-activedescendant');

        if (this.getSelection().length) {
            disabledFields.each(function (e) {
                $(this).removeAttr('disabled');
            });
        } else {
            disabledFields.each(function (e) {
                $(this).attr('disabled', true).val('');
            });
        }
    });
};

UX.quickSearch.magicSuggest = ($element, maxWords, maxChars) => {
    return $element.magicSuggest({
        data: '/action/doSuggest?target=title-auto-complete&pt=journal',
        method: 'GET',
        selectFirst: true,
        valueField: 'value',
        autoSelect: false,
        allowFreeEntries: 'false',
        displayField: 'label',
        cls: 'citationJournalName',
        hideTrigger: 'true',
        placeholder: $element.attr('placeholder'),
        maxSuggestions: 5,
        maxSelection: 1,
        maxSelectionRenderer: function () {
            return '';
        },
        beforeSend: function (xhr, settings) {
            let enteredTerm = settings.url.substr(settings.url.indexOf('query=') + 6).replace(/[​​+]/g, ' ');
            if (
                enteredTerm.split(' ').length > maxWords ||
                enteredTerm.length > maxChars ||
                !enteredTerm.replace(/\s/g, '').length
            ) {
                return false;
            }
        },
    });
};

UX.quickSearch.addTransition = () => {
    actualQuickSearchInputEl?.classList.remove('transition-none');
    searchTypeDropdownEl?.classList.remove('transition-none');
};

UX.quickSearch.removeTransition = () => {
    actualQuickSearchInputEl?.classList.add('transition-none');
    searchTypeDropdownEl?.classList.add('transition-none');
};

UX.quickSearch.handleQSAutocompleteA11Y = () => {
    const QSInput = document.querySelector('.actualQSInput');
    let suggestionList = document.querySelector('.quickSearchAutocomplete');
    let suggestions = [];
    let selectedIndex = -1;

    suggestionList?.setAttribute('role', 'listbox');
    suggestionList?.setAttribute('aria-label', 'Search suggestions');

    const updateFocus = suggestions => {
        suggestions.forEach((suggestion, index) => {
            if (index === selectedIndex) {
                suggestion.setAttribute('aria-selected', 'true');
                suggestion.setAttribute('id', `autosuggestion-option-${index + 1}`);
                suggestion.querySelector('.result-item').focus();
                QSInput.setAttribute('aria-activedescendant', suggestion.id);
            } else {
                suggestion.setAttribute('aria-selected', 'false');
            }
        });
    };

    QSInput.addEventListener('keydown', function (e) {
        suggestionList = document.querySelector('.quickSearchAutocomplete');
        suggestions = suggestionList.querySelectorAll('.qsaItem');

        if (suggestionList.style.display !== 'none' && suggestions.length > 0) {
            QSInput.setAttribute('aria-expanded', 'true');
            if (e.keyCode === keyCodes.DOWN) {
                e.preventDefault();
                selectedIndex = (selectedIndex + 1) % suggestions.length;
                updateFocus(suggestions);
            } else if (e.keyCode === keyCodes.UP) {
                e.preventDefault();
                selectedIndex = (selectedIndex - 1 + suggestions.length) % suggestions.length;
                updateFocus(suggestions);
            } else if (e.keyCode === keyCodes.ENTER) {
                e.preventDefault();
                const link = suggestions[selectedIndex]?.querySelector('.result-item')?.getAttribute('data-href');
                link && (window.location.href = link);
            }
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.keyCode === keyCodes.ESCAPE && suggestionList.style.display !== 'none') {
            suggestionList.style.display = 'none';
            QSInput.setAttribute('aria-expanded', 'false');
            selectedIndex = -1;
            setTimeout(() => {
                QSInput.focus();
            }, 200);
        }
    });
};
